module.exports = __webpack_public_path__ + "4c88bb4eeb37ffcbb3e0b429a8404786.png";